import { api } from "..";

const endpoint = "/api/warehouse-assignments";

export const getUserWarehouseList = (queryParams) => {
  return api.get(`${endpoint}`, { params: queryParams });
};

export const getUserWarehouseDetail = (id) => {
  return api.get(`${endpoint}/${id}`);
};

export const getUserWarehousesByUserId = (userId) => {
  return api.get(`${endpoint}/user/${userId}`);
};

export const getUserWarehousesByWarehouseId = (warehouseId) => {
  return api.get(`${endpoint}/warehouse/${warehouseId}`);
};

export const addUserWarehouse = (data) => {
  return api.post(`${endpoint}`, data);
};

export const updateUserWarehouse = (id, data) => {
  return api.put(`${endpoint}/${id}`, data);
};

export const deleteUserWarehouse = (id) => {
  return api.delete(`${endpoint}/${id}`);
};